const updateStickyHeader = () => {
  let announcement_bar = document.querySelector('.announcement-bar');
  let sticky_header = document.querySelector('sticky-header');
  let main_content = document.querySelector('#MainContent');

  if (announcement_bar && sticky_header) {
    const height = announcement_bar.getBoundingClientRect().height
    sticky_header.style.setProperty('top', `${height}px`, 'important');
  } else if (sticky_header) {
    sticky_header.style.setProperty('top', '0px', 'important');
  }

  let sticky_height = 0;
  if (sticky_header) {
    sticky_height = sticky_header.clientHeight + (announcement_bar ? announcement_bar.clientHeight : 0);
  }

  const getHeaderBarHeight = () => {
    if (sticky_header) {
      return sticky_header.getBoundingClientRect().height;
    }
    return 0;
  }
  const getAnnouncementBarHeight = () => {
    if (announcement_bar) {
      return announcement_bar.getBoundingClientRect().height;
    }
    return 0;
  }

  document.body.style.setProperty('--header-bar-height', `${getHeaderBarHeight()}px`);
  document.body.style.setProperty('--announcement-bar-height', `${getAnnouncementBarHeight()}px`);

  // if (main_content) {
  //   main_content.style.marginTop = `${sticky_height}px`;
  // }
}
document.addEventListener('DOMContentLoaded', updateStickyHeader);
window.onresize = updateStickyHeader;
var shopify_events = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect'];
shopify_events.forEach(function(event_type) {
  document.addEventListener(event_type, updateStickyHeader);
});
